import type { SVGProps } from "react"

export default function PlayIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 0V14L12 7L0 0Z"
        fill="currentColor"
      />
    </svg>
  )
}
